import { GzPolicyUiSettingsGridDataProvider } from '../../../../../../../common/policyPanel/uiSettings/gridTemplate/gridComponents/gridView/dataProvider/GzPolicyUiSettingsGridDataProvider';
import { Column, ColumnKeys } from './grid-config';
import { SetFiltersRequest } from '../../../../../../../../grid/types/common';
import { convertRegexFilterToStartsWithFilter } from '../../../../../../../common/policyPanel/uiSettings/gridTemplate/utils/filters-converters';
import { AntimalwareOnDemandScanTask } from '@nirvana/shared/dtos/types/policies/common';
import { sortByColumn } from './utils/sorters';
import { convertScanTaskStartDateDbValueToMilliseconds } from './utils/converters';

export interface AntimalwareOnDemandScanTaskFrontendFields extends AntimalwareOnDemandScanTask {
  startDate: number;
}

export class GzAntimalwareOnDemandScanTasksGridDataProvider extends GzPolicyUiSettingsGridDataProvider<
  Column,
  ColumnKeys,
  AntimalwareOnDemandScanTask
> {
  sortByColumnMethod(
    a: AntimalwareOnDemandScanTaskFrontendFields,
    b: AntimalwareOnDemandScanTaskFrontendFields,
    sortColumnName: string,
    sortDirection: string
  ): number {
    return sortByColumn(a, b, sortColumnName, sortDirection);
  }

  async setFilters(request: SetFiltersRequest<ColumnKeys>): Promise<{} | undefined> {
    // convert regex to startsWith
    convertRegexFilterToStartsWithFilter(request, ColumnKeys.NAME);
    return;
  }

  protected getItemsWithAdditionalFrontendFields(items: AntimalwareOnDemandScanTask[]): AntimalwareOnDemandScanTask[] {
    return items.map(item => {
      return {
        ...item,
        startDate: convertScanTaskStartDateDbValueToMilliseconds(item.scheduler.startDate),
      };
    });
  }
}
